module.exports = __webpack_public_path__ + "img/dhl.75ba8433.jpg";